export default {
  Title: 'Work Availability',
  Subtitle: 'Select the days and times you\'re available to work. Click and drag to select multiple slots.',
  TimePeriods: {
    Morning: {
      Label: 'Mornings',
      Subtitle: '6am-12pm',
    },
    Afternoon: {
      Label: 'Afternoons',
      Subtitle: '12pm-5pm',
    },
    Evening: {
      Label: 'Evenings',
      Subtitle: '5pm-9pm',
    },
    Night: {
      Label: 'Nights',
      Subtitle: '9pm-6am',
    },
  },
  Weekdays: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
  },
  Summary: {
    SlotsSelected: '#{selected} of #{total} time slots selected',
    DailyAvailability: 'Daily availability:',
    WeeklyTotal: 'Weekly Total:',
    Hours: 'hours',
    PleaseSelectSlot: 'Please select at least one time slot when you\'re available to work',
  },
};
